import React, {  useCallback, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../AuthContext';
import { TextField, DetailsList, SelectionMode,  PrimaryButton, DefaultButton } from '@fluentui/react';
const rootUrl = window.location.protocol + '//' + window.location.host + '/';

const reportColumns = [
    { key: "column1", name: "Name", fieldName: "name", minWidth: 100, maxWidth: 100, isResizable: true },
    { key: "column2", name: "Report Path", fieldName: "path", minWidth: 600, maxWidth: 700, isResizable: true },
    { key: "column3", name: "Description", fieldName: "description", minWidth: 300, maxWidth: 400, isResizable: true },
];
export const ReportEditor = () => {
    const authContext = useContext(AuthContext);
    const [reports, setReports] = useState([]);
    const [editedReport, setEditedReport] = useState(null);
    const onItemInvoked = (item, index) => {
        setEditedReport(item);
    };
    useEffect(() => {
        if (reports.length === 0 && authContext.isAuthenticated && authContext.accessToken && authContext.isAdministrator) {
            axios.get(rootUrl + "report", { headers: { 'Authorization': "Bearer " + authContext.accessToken }, }).then((result) => {
                setReports(result.data);
            });
        }

    }, [authContext, reports.length]);

    const onNameChange = useCallback((evt, newVal) => {
        var rpt = { ...editedReport };
        rpt.name = newVal;
        setEditedReport(rpt);
    }, [editedReport, reports]);
    const onDescriptionChange = useCallback((evt, newVal) => {
        var rpt = { ...editedReport };
        rpt.description = newVal;
        setEditedReport(rpt);
    }, [editedReport, reports]);
    const onPathChange = useCallback((evt, newVal) => {
        var rpt = { ...editedReport }
        rpt.path = newVal;
        setEditedReport(rpt);
    }, [editedReport, reports]);

    const onNewReport = useCallback(() => {
        var newReport = {
            id: "00000000-0000-0000-0000-000000000000",
            name: "",
            description: "",
            path: ""
        }
        setEditedReport(newReport);
    }, [reports]);
    const onSave = useCallback(() => {
        axios.post(rootUrl + "report", editedReport, { headers: { 'Authorization': "Bearer " + authContext.accessToken }, }).then((res) => {
            var reps = [...reports];
            var idx = reps.findIndex((el) => {
                return el.id == res.data.id;
            });
            if (idx > -1) {
                // exiting
                reps[idx] = res.data;
            } else {
                // new
                reps.push(res.data);
            }
            setReports(reps);
            setEditedReport(null);
        });
    }, [reports, editedReport]);
    const onDelete = useCallback(()=>{
        axios.delete(rootUrl + "report/" + editedReport.id, {headers: {'Authorization': "Bearer " + authContext.accessToken}}).then((res)=>{
            var rpts = [...reports];
            var idx = rpts.findIndex((el)=>el.id == editedReport.id);
            if (idx > -1){
                rpts.splice(idx, 1);
                setReports(rpts);
            }
            setEditedReport(null);
        });
    }, [reports, editedReport]);
    return (<div>

        <h2>Manage Reports</h2>
        {editedReport == null &&
            <div>
                <DetailsList items={reports}
                    columns={reportColumns}
                    selectionMode={SelectionMode.none}
                    onItemInvoked={onItemInvoked}></DetailsList>
                <PrimaryButton onClick={onNewReport}>Create New Report</PrimaryButton>
            </div>
        }
        {editedReport != null &&
            <div>
                <TextField label="Name" value={editedReport.name} onChange={onNameChange} />
                <TextField label="Description" value={editedReport.description} onChange={onDescriptionChange} />
                <TextField label="Path" value={editedReport.path} onChange={onPathChange} />
                <PrimaryButton onClick={onSave}>Save</PrimaryButton>
                <DefaultButton onClick={onDelete}>Delete</DefaultButton>
                <DefaultButton onClick={() => { setEditedReport(null); }}>Cancel</DefaultButton>

            </div>
        }

    </div>);
}

